import {debounceTime} from 'rxjs/operators';
import {Component, OnInit, OnChanges, Input} from '@angular/core';
import { UntypedFormGroup, UntypedFormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {TypesService, FormBuilderService, NotificationService} from '../../../services';
import {IndividualAssetModel} from '../../../models/widgets/assets-details-model';
import {Decimal} from 'decimal.js';
import * as _ from 'lodash';
import {BehaviorService} from '../../../services/behavior.service';
import {DataHandlerService} from '../../../services/data-handler.service';
import { OwnershipAllocationComponent } from '../ownership-allocation/ownership-allocation.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIf, NgFor } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import {
  MatInputCommifiedDirective
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/commified/mat-input-commified-directive';
import {
  FurtherAdvanceConfirmationComponent
} from '../further-advance-confirmation/further-advance-confirmation.component';

@Component({
    selector: 'app-assets-details',
    templateUrl: './assets-details.component.html',
    styles: [],
    standalone: true,
  imports: [MatCardModule, FormsModule, ReactiveFormsModule, NgIf, NgFor, MatFormFieldModule,
    MatInputModule, MatCheckboxModule, MatSelectModule, MatOptionModule,
    MatButtonModule, MatIconModule, OwnershipAllocationComponent, MatInputCommifiedDirective, FurtherAdvanceConfirmationComponent]
})

export class AssetsDetailsComponent extends WizardWidgetComponent implements OnInit, OnChanges {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public investmentFormArray: UntypedFormArray;
  @Input() public personList: any;
  @Input() public companyList: any;
  @Input() public trustList: any;
  @Input() public faType: string;
  @Input() public isSMSF = false;
  @Input() public isFurtherAdvance = false;

  public assetsFormArray: any;
  public assetTypesSlug = 'asset-types';
  public assetTypes = [];
  public refinanceAssetTypes = [];
  public removableFlags = [];


  constructor(public dataHandlerService: DataHandlerService,
              private typesService: TypesService,
              private formBuilderService: FormBuilderService,
              private notificationService: NotificationService,
              private behaviorService: BehaviorService) {
    super(dataHandlerService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.populateAssets();

    if (this.investmentFormArray) {
      console.debug('investmentFormArray', this.investmentFormArray.value);
      this.investmentFormArray.valueChanges.pipe(debounceTime(1000))
        .subscribe((val) => {
          this.computeTotalAssets();
        });
    }
  }

  handleAssetTypeChange(formGroup: UntypedFormGroup, type: String, index: number) {
    if (!this.refinanceAssetTypes.includes(type)) {
      formGroup.get('refinance').patchValue(false);
    }

    if (type === 'investment') {
      this.navigator.next('app-investment-income'); // 0 - based index
      this.assetsFormArray.removeAt(index);
      this.behaviorService.triggerRentalIncomeBehavior(BehaviorService.ADD_RENTAL_INCOME_BEHAVIOR);
      this.notificationService.toast('warn', 'Please input investment income details in "Rental Investment Incomes" panel.');
    }
  }

  ngOnChanges() {
    this.assetsFormArray = this.formGroup.get('assetsList');
  }

  public populateAssets() {
    this.typesService.getTypesList(this.assetTypesSlug)
      .then(results => {
        this.assetTypes = results;
        this.refinanceAssetTypes = _.map(_.filter(results, ['ext.refi', true]), 'id');
        this.initAssets();
      });
  }

  public initAssets() {
    if (this.assetsFormArray.controls.length === 0) {
    } else {
      // add flags after refresh
      for (let i = 0; i < this.assetsFormArray.controls.length; i++) {
        this.removableFlags.push(true);
      }
    }
    this.computeTotalAssets();
  }

  public addAsset(name) {
    console.log('[addAsset]', name);
    const asset = new IndividualAssetModel();
    if (name) {
      asset.type.value = name;
      this.removableFlags.push(false);
    } else {
      this.removableFlags.push(true);
    }

    const fg = this.formBuilderService.convertObjectToFormGroup(asset);
    this.formBuilderService.setValidationRules(new IndividualAssetModel(), fg);
    this.assetsFormArray.push(fg);
  }

  public removeAsset(index) {
    this.assetsFormArray.removeAt(index);
    this.removableFlags.splice(index, 1);
    this.computeTotalAssets();
  }

  public computeTotalAssets() {
    console.log('computeTotalAssets', this.assetsFormArray.getRawValue());

    let total = new Decimal(0);
    this.assetsFormArray.controls.forEach((ctrl) => {
      total = total.add(ctrl.value.amount || 0);
    });

    if (this.investmentFormArray) {
      this.investmentFormArray.controls.forEach((ctrl: UntypedFormGroup) => {
        if (!ctrl.getRawValue().isNewInvestment) {
          total = total.add(ctrl.getRawValue().assetValue || 0);
        }
      });
    }

    this.dataHandlerService.sendAssetChange();
    this.formGroup.get('totalAssetsValue').patchValue(total.toNumber());
  }
}
